import {
  LOGIN_REQUEST_USERNAME,
  LOGIN_SUCCESS_PHASE_ONE,
  LOGIN_SUCCESS_PHASE_ONE_NO_MFA,
  LOGIN_REQUEST_PHASE_ONE,
  LOGIN_ERROR_PHASE_ONE,
  LOGIN_REQUEST_PHASE_TWO,
  LOGIN_SUCCESS_PHASE_TWO,
  LOGIN_ERROR_PHASE_TWO,
  LOGIN_USERNAME_ERROR,
  JWT_VALIDATE_ERROR,
  JWT_VALIDATE_SUCCESS,
  USER_VALIDATE_ERROR,
  USER_VALIDATE_SUCCESS,
  LOGIN_ERROR_PHASE_ONE_LOCK,
  LOGIN_ERROR_PHASE_TWO_LOCK,
  LOGIN_RESET_WITH_USER,
  LOGIN_RESET,
  LOGOUT_REQUEST_SUCCESS,
  USER_UPDATE_REQUEST,
  USER_UPDATE_ERROR,
  USER_UPDATE_SUCCESS,
  USER_UPDATE_STATUS_RESET,
  AVATAR_UPDATE_SUCCESS,
  AVATAR_UPDATE_ERROR,
  SWITCH_COMPANY,
} from "actions";
import { saveCurrentMembership } from "services/memberships";
import { getCurrentCompanyProfile } from "services/companyProfile";
import { saveUserProfile } from "services/user";
const initialState = {
  status: "USERNAME_START",
  current_context: "USERNAME",
  context: "USERNAME",
  isAuthenticated: false,
  isFetching: true,
  attemptCount: 1,
  message: "HELLO. PLEASE ENTER YOUR EMAIL.",
};

export default function (state = initialState, action) {
  let currentMembership;
  switch (action.type) {
    case LOGIN_RESET_WITH_USER:
      return { ...state, ...action };
    case LOGIN_RESET:
      return { ...state, ...action };
    case LOGIN_REQUEST_USERNAME:
      return { ...state, ...action };
    case LOGIN_USERNAME_ERROR:
      return { ...state, ...action };
    case LOGIN_REQUEST_PHASE_ONE:
      return { ...state, ...action };
    case LOGIN_REQUEST_PHASE_TWO:
      return { ...state, ...action };
    case LOGIN_SUCCESS_PHASE_ONE:
      return { ...state, ...action, error: null, startTimeout: false };
    case LOGIN_SUCCESS_PHASE_ONE_NO_MFA:
      const currentCompanyProfile = getCurrentCompanyProfile();
      const membership = action.memberships;
      if (currentCompanyProfile) {
        currentMembership =
          membership.length > 0
            ? membership.filter(
                (m) => m.organizationId === currentCompanyProfile?.customer?.id
              )[0]
            : null;
      } else {
        currentMembership =
          action.memberships.length > 0 ? action.memberships[0] : null;
      }

      saveCurrentMembership(currentMembership);
      return {
        ...state,
        ...action,
        error: null,
        currentMembership,
      };
    case LOGIN_SUCCESS_PHASE_TWO:
      const currentCompanyProfile2 = getCurrentCompanyProfile();
      const membership2 = action.memberships;
      if (currentCompanyProfile2) {
        currentMembership =
          membership2.length > 0
            ? membership2.filter(
                (m) => m.organizationId === currentCompanyProfile?.customer?.id
              )[0]
            : null;
      } else {
        currentMembership =
          action.memberships.length > 0 ? action.memberships[0] : null;
      }

      saveCurrentMembership(currentMembership);
      return {
        ...state,
        ...action,
        currentMembership,
      };
    case LOGIN_ERROR_PHASE_ONE:
      return { ...state, ...action };
    case LOGIN_ERROR_PHASE_ONE_LOCK:
      return { ...state, ...action };
    case LOGIN_ERROR_PHASE_TWO:
      return { ...state, ...action };
    case LOGIN_ERROR_PHASE_TWO_LOCK:
      return { ...state, ...action };
    case JWT_VALIDATE_ERROR:
      return { ...state, ...action };
    case JWT_VALIDATE_SUCCESS:
      return { ...state, ...action };
    case USER_VALIDATE_ERROR:
      return { ...state, ...action };
    case USER_VALIDATE_SUCCESS:
      //save user in localCache
      const userProfile = action?.user;
      const memberships = action?.memberships;
      const eulaUserDetails = action?.eulaUserDetails;
      saveUserProfile({ userProfile, memberships, eulaUserDetails });
      return { ...state, ...action };
    case USER_UPDATE_REQUEST:
      return state;
    case USER_UPDATE_SUCCESS:
      return { ...state, user: action.user, type: action.type };
    case USER_UPDATE_ERROR:
      return { ...state, type: action.type };
    case USER_UPDATE_STATUS_RESET:
      return { ...state, ...action };
    case AVATAR_UPDATE_ERROR:
      return state;
    case AVATAR_UPDATE_SUCCESS:
      const { user } = state;
      user.userProfile.userImage = action.userImage;
      user.userProfile.profileImage = action.imageId;
      return { ...state, ...action };
    case "MFA_REQUEST_OPTION":
      return { ...state, message: action.message };
    case "MFA_REQUEST_SUCCESS":
      return { ...state, message: action.message, startTimeout: true };
    case "MFA_REQUEST_ERROR":
      return { ...state, message: action.message };
    case "MFA_ENTER_TIMEOUT1":
      return { ...state, message: action.message, type: "MFA_ENTER_TIMEOUT1" };
    case "MFA_ENTER_TIMEOUT2":
      return { ...state, message: action.message, type: "MFA_ENTER_TIMEOUT2" };
    case SWITCH_COMPANY:
      saveCurrentMembership(action.currentMembership);
      return { ...state, ...action };
    case LOGOUT_REQUEST_SUCCESS:
      return { ...initialState };
    default:
      return state;
  }
}
